import React from 'react';
import { Box, Typography } from '@mui/material';
import Carousel from './Carousel';

const RecentNews = ({ recentNewsData }) => (
    <Box sx={{ mx: { xs: 2, sm: 4, md: 6, lg: 8 }, mt: 8, mb: 5 }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'left', ml: { xs: 2, sm: 4 } }}>
            Recent News
        </Typography>
        <Carousel content={recentNewsData} slidesPerView={4} spaceBetween={10} isRecentNews={true} />
    </Box>
);

export default RecentNews;
